const UpdateNetworkUserAdminApproved = `
  mutation UpdateNetworkUserAdminApproved(
    $network_uuid: uuid!,
    $user_uuid: uuid!,
    $approved: Boolean
  ) {
    update_network_user_by_pk(
      pk_columns: {network_uuid: $network_uuid, user_uuid: $user_uuid},
      _set: {admin_approved: $approved}
    ) {
      __typename
      user_uuid
      network_uuid
    }
  }
`;

export default UpdateNetworkUserAdminApproved;
